import useApiRequest from 'api/useApiRequest';
import {
  fetchTranscriptsEvents,
  fetchTranscriptsDebates,
  createDiarisedTranscript,
  fetchListTranscripts,
  fetchDownloadTranscript,
  deleteTranscript,
  updateDiarisedTranscript,
} from 'api/services/transcriptsService';

const useTranscripts = () => {
  const { request } = useApiRequest();

  const getTranscriptsEvents = async (params: Parameters<typeof fetchTranscriptsEvents>[1]) => {
    const { data } = await fetchTranscriptsEvents(request, params);
    return data;
  };

  const getTranscriptsDebates = async (params: Parameters<typeof fetchTranscriptsDebates>[1]) => {
    const { data } = await fetchTranscriptsDebates(request, params);
    return data;
  };

  const createTranscript = async (params: Parameters<typeof createDiarisedTranscript>[1]) => {
    const { data, status } = await createDiarisedTranscript(request, params);
    return { data, status };
  };

  const updateTranscript = async (params: Parameters<typeof updateDiarisedTranscript>[1]) => {
    const { data, status } = await updateDiarisedTranscript(request, params);
    return { data, status };
  };

  const getListTranscripts = async (params: Parameters<typeof fetchListTranscripts>[1]) => {
    const { data } = await fetchListTranscripts(request, params);
    return data;
  };

  const downloadTranscript = async (params: Parameters<typeof fetchDownloadTranscript>[1]) => {
    const { data, headers } = await fetchDownloadTranscript(request, params);
    return { blob: data, filename: headers?.['content-disposition']?.match(/filename="?([^"]+)"?/i)?.[1] };
  };

  const removeTranscript = async (params: Parameters<typeof deleteTranscript>[1]) => {
    const { status } = await deleteTranscript(request, params);
    return { status };
  };

  return {
    getTranscriptsEvents,
    getTranscriptsDebates,
    createTranscript,
    getListTranscripts,
    downloadTranscript,
    updateTranscript,
    removeTranscript,
  };
};

export default useTranscripts;
